import React, { Fragment } from "react";

import {
  Grid,
  LinearProgress,
  Typography,
  colors,
  makeStyles,
} from "@material-ui/core";

import { OverallProgressProps } from "./types";
import Skeleton from "./components/Skeleton";

const useStyles = makeStyles(() => ({
  overallPercentageTitle: {
    fontWeight: 300,
    fontSize: "2rem",
    letterSpacing: "-0.8px",
  },
  overallPercentageText: {
    fontWeight: 400,
    fontSize: "0.75rem",
    letterSpacing: "-0.4px",
    color: colors.blueGrey[600],
  },
  overallPercentageProgressBar: {
    width: "100%",
  },
}));

const OverallProgress: React.FC<OverallProgressProps> = ({
  loading = false,
  overallProgressPercentage = undefined,
}) => {
  const classes = useStyles();

  if (loading) {
    return <Skeleton />;
  }

  return (
    <Fragment>
      <Grid container direction="row" justify="space-between">
        <Grid container item direction="column" xs={3} sm={2} md={1}>
          <Fragment>
            <Typography variant="h1" className={classes.overallPercentageTitle}>
              {overallProgressPercentage || 0}%
            </Typography>
            <Typography
              variant="body1"
              className={classes.overallPercentageText}
            >
              Overall progress
            </Typography>
          </Fragment>
        </Grid>
        <Grid
          container
          item
          direction="row"
          xs={8}
          sm={9}
          md={10}
          justify="center"
          alignItems="center"
          spacing={1}
        >
          <LinearProgress
            variant="determinate"
            value={overallProgressPercentage || 0}
            className={classes.overallPercentageProgressBar}
          />
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default OverallProgress;
